import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class BraxosInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.braxosInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.braxosInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.braxosInvalidFieldError.code;
    this.message = `${message} ${errorCodes.braxosInvalidFieldError.code}`;
    this.name = errorCodes.braxosInvalidFieldError.name;
  }
}
